<template>
  <div class="loading-overlay" role="status" :class="[getPosition, { 'overlay-search-results': overlay === 'search-results' }]">
    <md-progress-spinner
      md-mode="indeterminate"
      :md-stroke="2"
    ></md-progress-spinner>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: ['position', 'overlay'],
  computed: {
    getPosition() {
      switch (this.position) {
        case 'relative': return 'loading-relative';
        case 'absolute': return 'loading-absolute';
        default: return '';
      }
    }
  }
}
</script>

<style scoped>
  .loading-overlay {
    z-index: 2000;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .overlay-search-results {
    z-index: 2000;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.1) !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<style lang="scss" scoped>
.loading-relative {
  position: relative;
}
.loading-absolute {
  position: absolute;
}
</style>
